import { useEffect, useState } from 'react';
import { getData } from '../../utils/apiCalls';
import { ImgLoader } from '../ImgLoader';
import { duplicateArrayElements, randomizeArray } from '../../utils/funcs';
import { svgs } from '../../assets/svgs';
import vc_logos from '../../data/vc_logos.json'


export const VCLogos = () => {
    const [data, setData] = useState([[], []])

    useEffect(() => {
        // if (sessionStorage.getItem('vc_logos')) {
        //     return setData(JSON.parse(sessionStorage.getItem('vc_logos')))
        // }
        // getData(`https://youngstartup.io/api/cwebsite/get_speaker_logos`)
        //     .then(res => {
        //         const half = (res.length / 2)
        //         const logos1 = res.slice(0, half - 1)
        //         const logos2 = res.slice(half, -1)
        //         setData([logos1, logos2])
        //         sessionStorage.setItem('vc_logos', JSON.stringify([logos1, logos2]))
        //     })
        const half = (vc_logos.length / 2)
        const logos1 = vc_logos.slice(0, half - 1)
        const logos2 = vc_logos.slice(half, -1)
        setData([logos1, logos2])
    }, [])

    return (
        <div>
            <div className='vc-logos'>
                <div className="slider">
                    <div className="slide-track" style={{ width: 200 * 100 + 'px' }}>
                        {duplicateArrayElements(randomizeArray(data[0]), 100).map((i, idx) =>
                            <div key={idx} className="slide">
                                <ImgLoader src={require(`../../assets/imgs/vc_logos/${i.logo_url}`)} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className='vc-logos'>
                <div className="slider">
                    <div className="slide-track" style={{ width: 200 * 100 + 'px' }}>
                        {duplicateArrayElements(randomizeArray(data[1]), 100).map((i, idx) =>
                            <div key={idx} className="slide">
                                <ImgLoader src={require(`../../assets/imgs/vc_logos/${i.logo_url}`)} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}


